import { configureStore } from '@reduxjs/toolkit'
import data from './reducers/data'

export default configureStore({
	reducer: {
		data: data
	}
})
